// extracted by mini-css-extract-plugin
export default {"close-button":"close-button--dd53b2","closeButton":"close-button--dd53b2"};